import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: any; output: any; }
  JSON: { input: any; output: any; }
};

export type DeleteSurveyAttachmentInput = {
  attachmentId: Scalars['ID']['input'];
};

export type GetSurveyAttachmentDownloadUrlInput = {
  attachmentId: Scalars['ID']['input'];
};

export type Mutation = {
  __typename?: 'Mutation';
  deleteSurveyAttachment: Scalars['Boolean']['output'];
  updateSurveyResponse: SurveyResponse;
};


export type MutationDeleteSurveyAttachmentArgs = {
  input: DeleteSurveyAttachmentInput;
};


export type MutationUpdateSurveyResponseArgs = {
  input: UpdateSurveyResponseInput;
};

export type Query = {
  __typename?: 'Query';
  getSurveyAttachmentDownloadUrl: SurveyAttachmentDownloadUrl;
  getSurveyResponseAttachments: Array<SurveyResponseAttachment>;
  getSurveyResponseById?: Maybe<SurveyResponse>;
};


export type QueryGetSurveyAttachmentDownloadUrlArgs = {
  input: GetSurveyAttachmentDownloadUrlInput;
};


export type QueryGetSurveyResponseAttachmentsArgs = {
  surveyResponseId: Scalars['ID']['input'];
};


export type QueryGetSurveyResponseByIdArgs = {
  id: Scalars['String']['input'];
};

export type SurveyAttachmentDownloadUrl = {
  __typename?: 'SurveyAttachmentDownloadUrl';
  fileName: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type SurveyResponse = {
  __typename?: 'SurveyResponse';
  answers?: Maybe<Scalars['JSON']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  completedBy?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  inviteId: Scalars['String']['output'];
  surveyId: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type SurveyResponseAttachment = {
  __typename?: 'SurveyResponseAttachment';
  contentType: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  fileName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  questionName: Scalars['String']['output'];
  sizeBytes: Scalars['Int']['output'];
  surveyResponseId: Scalars['ID']['output'];
};

export type UpdateSurveyResponseInput = {
  answers: Scalars['String']['input'];
  complete?: InputMaybe<Scalars['Boolean']['input']>;
  expectedUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['ID']['input'];
};

export type UpdateSurveyResponseMutationVariables = Exact<{
  input: UpdateSurveyResponseInput;
}>;


export type UpdateSurveyResponseMutation = { __typename?: 'Mutation', updateSurveyResponse: { __typename?: 'SurveyResponse', id: string, updatedAt?: any | null } };

export type GetSurveyResponseByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetSurveyResponseByIdQuery = { __typename?: 'Query', getSurveyResponseById?: { __typename?: 'SurveyResponse', answers?: any | null, updatedAt?: any | null, completedAt?: any | null } | null };

export type DeleteSurveyAttachmentMutationVariables = Exact<{
  input: DeleteSurveyAttachmentInput;
}>;


export type DeleteSurveyAttachmentMutation = { __typename?: 'Mutation', deleteSurveyAttachment: boolean };

export type GetSurveyAttachmentDownloadUrlQueryVariables = Exact<{
  input: GetSurveyAttachmentDownloadUrlInput;
}>;


export type GetSurveyAttachmentDownloadUrlQuery = { __typename?: 'Query', getSurveyAttachmentDownloadUrl: { __typename?: 'SurveyAttachmentDownloadUrl', url: string, fileName: string } };

export type GetSurveyResponseAttachmentsQueryVariables = Exact<{
  surveyResponseId: Scalars['ID']['input'];
}>;


export type GetSurveyResponseAttachmentsQuery = { __typename?: 'Query', getSurveyResponseAttachments: Array<{ __typename?: 'SurveyResponseAttachment', id: string, questionName: string, fileName: string, contentType: string, sizeBytes: number, createdAt: any }> };


export const UpdateSurveyResponseDocument = gql`
    mutation UpdateSurveyResponse($input: UpdateSurveyResponseInput!) {
  updateSurveyResponse(input: $input) {
    id
    updatedAt
  }
}
    `;

export function useUpdateSurveyResponseMutation() {
  return Urql.useMutation<UpdateSurveyResponseMutation, UpdateSurveyResponseMutationVariables>(UpdateSurveyResponseDocument);
};
export const GetSurveyResponseByIdDocument = gql`
    query GetSurveyResponseById($id: String!) {
  getSurveyResponseById(id: $id) {
    answers
    updatedAt
    completedAt
  }
}
    `;

export function useGetSurveyResponseByIdQuery(options: Omit<Urql.UseQueryArgs<GetSurveyResponseByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<GetSurveyResponseByIdQuery, GetSurveyResponseByIdQueryVariables>({ query: GetSurveyResponseByIdDocument, ...options });
};
export const DeleteSurveyAttachmentDocument = gql`
    mutation DeleteSurveyAttachment($input: DeleteSurveyAttachmentInput!) {
  deleteSurveyAttachment(input: $input)
}
    `;

export function useDeleteSurveyAttachmentMutation() {
  return Urql.useMutation<DeleteSurveyAttachmentMutation, DeleteSurveyAttachmentMutationVariables>(DeleteSurveyAttachmentDocument);
};
export const GetSurveyAttachmentDownloadUrlDocument = gql`
    query GetSurveyAttachmentDownloadUrl($input: GetSurveyAttachmentDownloadUrlInput!) {
  getSurveyAttachmentDownloadUrl(input: $input) {
    url
    fileName
  }
}
    `;

export function useGetSurveyAttachmentDownloadUrlQuery(options: Omit<Urql.UseQueryArgs<GetSurveyAttachmentDownloadUrlQueryVariables>, 'query'>) {
  return Urql.useQuery<GetSurveyAttachmentDownloadUrlQuery, GetSurveyAttachmentDownloadUrlQueryVariables>({ query: GetSurveyAttachmentDownloadUrlDocument, ...options });
};
export const GetSurveyResponseAttachmentsDocument = gql`
    query GetSurveyResponseAttachments($surveyResponseId: ID!) {
  getSurveyResponseAttachments(surveyResponseId: $surveyResponseId) {
    id
    questionName
    fileName
    contentType
    sizeBytes
    createdAt
  }
}
    `;

export function useGetSurveyResponseAttachmentsQuery(options: Omit<Urql.UseQueryArgs<GetSurveyResponseAttachmentsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetSurveyResponseAttachmentsQuery, GetSurveyResponseAttachmentsQueryVariables>({ query: GetSurveyResponseAttachmentsDocument, ...options });
};